<ng-container *ngIf="temporaryCustomer">
	<div class="dialog-header">
		<div class="header-title"><span style="font-size: 145%;">{{header}}</span></div>

		<button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
			<mat-icon>clear</mat-icon>
		</button>
	</div>
	<div class="middle-content">
		<div class="contacts-loading-screen" *ngIf="customerLoading">
			<lib-progress-spinner></lib-progress-spinner>
		</div>
		<form #editVendorForm="ngForm" *ngIf="!customerLoading">

			<div class="customer-row row-block">
				<div class="customer-row-title row-title">Vendor</div>
				<div class="customer-block div-block">
					<div class="customer-info row-block">
						<div class="customer-label">Name:</div>
						<div class="customer-span">
							<input class="text-input" type="text" [(ngModel)]="temporaryCustomer.name" name="name">
						</div>
					</div>
					<div class="customer-info row-block">
						<div class="customer-label">E-Mail:</div>
						<div class="customer-span">
							<input class="text-input" type="text" [(ngModel)]="temporaryCustomer.eMail" name="eMail">
						</div>
					</div>
					<div class="customer-info row-block">
						<div class="customer-label">Phone:</div>
						<div class="customer-span">
							<input class="text-input" type="text" [(ngModel)]="temporaryCustomer.phone" name="phone">
						</div>
					</div>
					<div class="customer-info row-block">
						<div class="customer-label">City:</div>
						<div class="customer-span">
							<input class="text-input" type="text" [(ngModel)]="temporaryCustomer.city" name="city">
						</div>
					</div>
					<div class="customer-info row-block">
						<div class="customer-label">Address:</div>
						<div class="customer-span">
							<input class="text-input" type="text" [(ngModel)]="temporaryCustomer.address1"
								name="address1">
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</ng-container>